export const ADD_AUCTIONEER = 'ADD_AUCTIONEER';
export const GET_AUCTIONEERS = 'GET_AUCTIONEERS';
export const EDIT_AUCTIONEER = 'EDIT_AUCTIONEER';
export const DELETE_AUCTIONEER = 'DELETE_AUCTIONEER';

